function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.02,
  cy: 6,
  rx: 5.52,
  ry: 6,
  fill: "#808080"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3087 3.84184L6.04274 8.76853C6.00261 8.85834 5.93534 8.90324 5.84092 8.90324C5.82912 8.90324 5.81142 8.90068 5.78781 8.89555C5.73589 8.88272 5.69399 8.85385 5.66212 8.80894C5.63026 8.76404 5.61433 8.71336 5.61433 8.65691V6.4399H3.57496C3.52303 6.4399 3.47641 6.42258 3.43511 6.38794C3.3938 6.3533 3.36725 6.30775 3.35544 6.2513C3.34364 6.19485 3.34836 6.14096 3.36961 6.08964C3.39085 6.03832 3.42507 5.99983 3.47228 5.97417L8.00421 3.51083C8.0349 3.49287 8.06912 3.48389 8.10689 3.48389C8.17062 3.48389 8.22373 3.50826 8.26621 3.55702C8.30162 3.59294 8.32345 3.6372 8.33171 3.68981C8.33997 3.74241 8.3323 3.79309 8.3087 3.84184Z",
  fill: "white"
});

function SvgDirections(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/directions.8f76591d.svg";
export { ForwardRef as ReactComponent };